<i class="display-catchup-visibility fal fa-fw fa-lock"
   aria-hidden="true"
   [adaptTooltip]="explanationText"></i>
